export default __webpack_public_path__ + "static/media/cst_500_men_jacket.aa5e0f61.jpg";